import { useState } from 'react';

const statusOptions = [
  { value: '', label: 'Todos' },
  { value: '0', label: 'Ativo' },
  { value: '1', label: 'Em Avaliação' },
  { value: '2', label: 'Cadastrado' },
  { value: '3', label: 'Ex Paciente' },
  { value: '4', label: 'Pausado' },
];

const shiftOptions = [
  { value: '', label: 'Todos' },
  { value: '0', label: 'Manhã' },
  { value: '1', label: 'Tarde' },
];

const PacientesFilters = ({
  searchInput,
  onSearchChange,
  onSearchSubmit,
  statusFilter,
  onStatusChange,
  modalityFilter,
  onModalityChange,
  shiftFilter,
  onShiftChange,
  modalidades = [],
  onClearFilters,
}) => {
  // Garantir que os valores sejam strings (não undefined/null)
  const safeSearchInput = searchInput || '';
  const safeStatusFilter = statusFilter || '';
  const safeModalityFilter = modalityFilter || '';
  const safeShiftFilter = shiftFilter || '';
  
  // Verificar se há filtros ativos
  const hasSearch = safeSearchInput.trim().length > 0;
  const hasStatus = safeStatusFilter !== '';
  const hasModality = safeModalityFilter !== '';
  const hasShift = safeShiftFilter !== '';
  
  const hasActiveFilters = hasSearch || hasStatus || hasModality || hasShift;

  const activeFiltersCount =
    (hasSearch ? 1 : 0) + (hasStatus ? 1 : 0) + (hasModality ? 1 : 0) + (hasShift ? 1 : 0);

  const [filtrosExpandidos, setFiltrosExpandidos] = useState(false);

  return (
    <div className="card mb-4" style={{ border: '1px solid #dee2e6' }}>
      <div
        className="card-header d-flex justify-content-between align-items-center"
        style={{
          cursor: 'pointer',
          backgroundColor: '#f8f9fa',
          borderBottom: filtrosExpandidos ? '1px solid #dee2e6' : 'none',
          borderBottomLeftRadius: filtrosExpandidos ? 0 : 'inherit',
          borderBottomRightRadius: filtrosExpandidos ? 0 : 'inherit',
          padding: '0.5rem 1rem',
        }}
        onClick={() => setFiltrosExpandidos(!filtrosExpandidos)}
      >
        <h6 className="mb-0 d-flex align-items-center">
          <i className="fas fa-filter me-2" style={{ color: '#47a0be' }}></i>
          Filtros
          {activeFiltersCount > 0 && (
            <small className="text-muted ms-2">
              ({activeFiltersCount} {activeFiltersCount === 1 ? 'filtro ativo' : 'filtros ativos'})
            </small>
          )}
        </h6>
        <i
          className={`fas ${filtrosExpandidos ? 'fa-chevron-up' : 'fa-chevron-down'}`}
          style={{ color: '#47a0be', transition: 'transform 0.2s ease' }}
        ></i>
      </div>

      {filtrosExpandidos && (
      <div className="card-body p-3">
        <div className="row g-3">
          <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label text-sm font-weight-bold mb-1">Pesquisar</label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Digite o nome do paciente"
              value={safeSearchInput}
              onChange={(e) => onSearchChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onSearchSubmit();
                }
              }}
            />
          </div>
          <div className="col-12 col-md-6 col-lg-2">
            <label className="form-label text-sm font-weight-bold mb-1">Status</label>
            <select
              className="form-control form-control-sm"
              value={safeStatusFilter}
              onChange={(e) => onStatusChange(e.target.value)}
            >
              {statusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-6 col-lg-2">
            <label className="form-label text-sm font-weight-bold mb-1">Modalidade</label>
            <select
              className="form-control form-control-sm"
              value={safeModalityFilter}
              onChange={(e) => onModalityChange(e.target.value)}
            >
              <option value="">Todas</option>
              {modalidades.map((modalidade) => (
                <option key={modalidade.id} value={modalidade.id}>
                  {modalidade.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-6 col-lg-2">
            <label className="form-label text-sm font-weight-bold mb-1">Turno</label>
            <select
              className="form-control form-control-sm"
              value={safeShiftFilter}
              onChange={(e) => onShiftChange(e.target.value)}
            >
              {shiftOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          {onClearFilters && (
            <div className="col-12 col-md-6 col-lg-3 d-flex flex-column justify-content-end">
              <label className="form-label text-sm font-weight-bold mb-1">&nbsp;</label>
              {hasActiveFilters && (
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={onClearFilters}
                  style={{ 
                    fontSize: '0.75rem',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <i className="bi bi-x-circle me-1"></i>
                  Limpar filtros
                </button>
              )}
            </div>
          )}
        </div>
      </div>
      )}
    </div>
  );
};

export default PacientesFilters;

